<div class="d-flex flex-column" style="height: 70vh;">
    <div class="table-responsive" style="min-height: 50vh; overflow: auto;">
        <table class="table table-bordered">
            <thead class="table-dark">
                <tr class="text-wrap" style="position: sticky;top: 0;">
                    <th *ngIf="isExpandable"></th>
                    <th *ngFor="let item of columnName" [ngClass]="{'cursor-pointer': item.hasSort}" class="col p-3"
                        (click)="sortColumn(item)">
                        <span *ngIf="item.hasSort">
                            <i *ngIf="sortedColumn === item.name && sortOrder === 'asc'; else desc"
                                class="fa fa-sort-amount-asc" aria-hidden="true"></i>
                            <ng-template #desc>
                                <i *ngIf="sortedColumn === item.name" class="fa fa-sort-amount-desc"
                                    aria-hidden="true"></i>
                            </ng-template>
                        </span>
                        {{item.title}}
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let item of data; let i = index">
                    <tr>
                        <td *ngIf="isExpandable" (click)="ExpandCollapse(item , i)" class="cursor-pointer">
                            <span>
                                <div *ngIf="expandedRows[i];else mines">
                                    <i class="fa fa-2x fa-angle-up" aria-hidden="true"></i>
                                </div>
                                <ng-template #mines>
                                    <i class="fa fa-2x fa-angle-down" aria-hidden="true"></i>
                                </ng-template>
                            </span>
                        </td>
                        <td *ngFor="let key of KeyName">
                            <span *ngIf="!key.pipe && !key.hasLink&& !key.onClick && !key.isBoolean">
                                {{ item[key.name] }}
                            </span>
                            <span *ngIf="key.pipe">
                                <div *ngIf="item[key.name] >= 0;else handleNegativeNumber"
                                    [ngbTooltip]="convertToToman(item[key.name] | number)" tooltipClass="tooltip-class">
                                    {{ item[key.name] | number }}
                                </div>
                                <ng-template #handleNegativeNumber>
                                    <span class="text-danger" [ngbTooltip]="convertToToman(item[key.name] | number)"
                                        tooltipClass="tooltip-class-negative">
                                        <bdi>
                                            {{ item[key.name] | number }}

                                        </bdi>
                                    </span>
                                </ng-template>
                            </span>
                            <span *ngIf="key.hasLink && key.hasView">
                                <a [href]="item[key.name]" target="_blank">
                                    
                                    <i *ngIf="item[key.name]" class="fa fa-eye text-info" aria-hidden="true"></i>
                                </a>
                            </span>
                            <span *ngIf="key.onClick && key.hasEdit" (click)="clickOnTd({action: 'edit', data: item[key.uniqueKey]})"
                                class="cursor-pointer">
                                <i class="fa fa-pencil-square-o text-success mx-1" title="ویرایش" aria-hidden="true"></i>
                            </span>
                            <span *ngIf="key.onClick && key.hasView" (click)="clickOnTd({action: 'view', data: item[key.uniqueKey]})"
                                class="cursor-pointer">
                                <i class="fa fa-eye text-info mx-1" title="مشاهده جزئیات" aria-hidden="true"></i>
                            </span>
                            <span *ngIf="key.onClick && key.hasModal" (click)="clickOnTd(item)" title="{{key.title}}"
                                class="cursor-pointer">
                                <i class="{{key.iconClass}}" aria-hidden="true"></i>
                            </span>
                            <span *ngIf="key.isBoolean">
                                <span *ngIf="item[key.name].length > 0;else isFalse">
                                    <i class="fa fa-check text-success" aria-hidden="true"></i>
                                </span>
                                <ng-template #isFalse>
                                    <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                </ng-template>
                            </span>

                        </td>
                    </tr>
                    <tr *ngIf="expandedRows[i]">
                        <td colspan="9">
                            <table class="table table-bordered table-hover">
                                <thead class="table-dark">
                                    <tr class="text-wrap" style="position: sticky;top: 0;">
                                        <th *ngFor="let childHeader of columnNameChild" class="col p-3">
                                            {{childHeader}}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- ----  {{item['items'] | json}}--- -->
                                    <tr *ngFor="let childItem of children">
                                        <td *ngFor="let childKey of KeyNameChild">
                                            <span *ngIf="!childKey.pipe && !childKey.hasLink&& !childKey.onClick">
                                                {{ childItem[childKey.name] }}
                                            </span>
                                            <span *ngIf="childKey.pipe">
                                                <!-- {{ childItem[childKey.name] | number }} -->
                                                <div *ngIf="childItem[childKey.name] >= 0;else handleNegativeNumber"
                                                    [ngbTooltip]="convertToToman(childItem[childKey.name] | number)"
                                                    tooltipClass="tooltip-class">
                                                    {{childItem[childKey.name] | number }}
                                                </div>
                                                <ng-template #handleNegativeNumber>
                                                    <span class="text-danger" tooltipClass="tooltip-class-negative"
                                                        [ngbTooltip]="convertToToman(childItem[childKey.name] | number)">
                                                        <bdi>
                                                            {{ Math.abs(childItem[childKey.name]) | number }}

                                                        </bdi>
                                                    </span>
                                                </ng-template>

                                            </span>
                                        </td>
                                    </tr>
                                    <tr class="text-right" *ngIf="children && children?.length === 0">
                                        <td colspan="16" class="font-1" style="text-align: right;">
                                            اطلاعاتی جهت نمایش وجود نمی باشد ...
                                        </td>
                                    </tr>
                                    <tr *ngIf="isLoadingChild">
                                        <td colspan="16" style="text-align: center;">
                                            <div *ngIf="isLoadingChild" class="spinner-border text-primary"></div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </td>
                    </tr>
                </ng-container>
                <tr class="text-right" *ngIf="data && data.length === 0">
                    <td colspan="16" class="font-1" style="text-align: right;">
                        اطلاعاتی جهت نمایش وجود نمی باشد ...
                    </td>
                </tr>
                <tr *ngIf="isLoading">
                    <td colspan="16" style="text-align: center;">
                        <div class="spinner-border text-primary"></div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <hr />
    <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center justify-content-between">
            <ngb-pagination [collectionSize]="totalRecords" [pageSize]="pageSize" [(page)]="page" [maxSize]="5"
                [boundaryLinks]="true" (pageChange)="changePage($event)"
                style="position: relative;top: 0.5rem;"></ngb-pagination>

            <div class="d-flex justify-content-between p-2">
                <select class="form-select" style="width: auto" name="pageSize" (change)="changeSize($event)">
                    <option [ngValue]="20">20</option>
                    <option [ngValue]="50">50</option>
                    <option [ngValue]="100">100</option>
                </select>
            </div>
        </div>
        <div class="d-flex align-items-center">
            {{ getDisplayedRange() }}
        </div>
    </div>
</div>